import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';

Header.propTypes = {
  offer: PropTypes.shape({
    data: PropTypes.shape({
      activityId: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  }),
}
export default function Header(props) {
  const { offer } = props;

  const activity = useConnect('tag.byId', {
    id: offer.data.activityId
  });

  return (
    <div className="flex flex-col space-y-2">
      <div className="space-y-0.5">
        <div className="text-lg font-semibold text-cs-gray-900">
          {offer.data.title || activity?.data?.name || 'UNTITLED'}
        </div>
        <div className="text-base text-cs-gray-500 line-clamp-3">
          {offer.data.description || activity?.data?.description || 'NO DESCRIPTION'}
        </div>
      </div>
    </div>
  );
}
